import { useQuery } from '@apollo/client';
import { Box, Heading, Skeleton, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useHistory } from 'react-router-dom';

import {
  GetUserQueryGQLType,
  GetUserQueryVariablesGQLType,
} from 'types/dashboard-core-gqlTypes.generated.d';

import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { CreditAgreementsOverviewTable } from 'packages/creditAgreements/ui/CreditAgreementArtifact/CreditAgreementOverviewTable';
import { GET_USER } from 'requests/queries.gql';

export const CreditAgreementsOverview: React.FC<{}> = () => {
  const toast = useToast();
  const history = useHistory();
  const { data: userData, loading: userLoading } = useQuery<
    GetUserQueryGQLType,
    GetUserQueryVariablesGQLType
  >(GET_USER);

  if (userLoading || !userData || !userData.user) {
    return (
      <Skeleton
        height="600px"
        data-testid="credit-agreements-overview-route-loading"
      />
    );
  }

  let routeLevelError = false;
  return (
    <Box className="main">
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to credit agreements overview page`;
            routeLevelError = true;
            toast(errorToastConfig);
            history.push('/');
          }
        }}
      >
        <Heading as="h2">Credit Agreements Overview</Heading>
        <CreditAgreementsOverviewTable
          organizationId={userData.user.organizationId}
        />
      </Sentry.ErrorBoundary>
    </Box>
  );
};
